import React from 'react';

interface ColorCodedEventProps {
  title: string;
  time: string;
  color: string;
  type?: string;
  status: 'past' | 'current' | 'upcoming' | 'tomorrow';
  largeFont?: boolean; // backwards compat, ignored
}

const paletteMap: Record<string, { bg: string; accent: string; text: string; pastBg: string; pastBorder: string }> = {
  meal: {
    bg: '#fff3e0',
    accent: '#f57c00',
    text: '#bf360c',
    pastBg: '#fff8f0',
    pastBorder: 'rgba(245,124,0,0.2)',
  },
  medication: {
    bg: '#ffebee',
    accent: '#e53935',
    text: '#b71c1c',
    pastBg: '#fff5f5',
    pastBorder: 'rgba(229,57,53,0.2)',
  },
  other: {
    bg: '#f3e5f5',
    accent: '#7b1fa2',
    text: '#4a148c',
    pastBg: '#faf5ff',
    pastBorder: 'rgba(123,31,162,0.2)',
  },
};

export const ColorCodedEvent: React.FC<ColorCodedEventProps> = ({ title, time, type = 'other', status }) => {
  const palette = paletteMap[type] ?? paletteMap.other;

  if (status === 'past') {
    return (
      <div style={{ width: '100%', height: 32, boxSizing: 'border-box', borderRadius: 8, backgroundColor: palette.pastBg, border: `1px solid ${palette.pastBorder}`, display: 'flex', alignItems: 'center', padding: '0 10px', marginBottom: 4, overflow: 'hidden' }}>
        <span style={{ fontSize: 13, color: '#bbb', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {time} — {title}
        </span>
      </div>
    );
  }

  if (status === 'current') {
    return (
      <div style={{ width: '100%', height: 88, boxSizing: 'border-box', borderRadius: 10, backgroundColor: palette.bg, border: `2px solid ${palette.accent}`, display: 'flex', alignItems: 'center', padding: '0 16px', marginBottom: 8, position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 6, backgroundColor: palette.accent }} />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10, flex: 1, minWidth: 0 }}>
          <span style={{ fontSize: 30, fontWeight: 700, color: palette.text, lineHeight: 1.2 }}>{time}</span>
          <span style={{ fontSize: 24, color: palette.text, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: 1.3 }}>{title}</span>
        </div>
        <div style={{ position: 'absolute', top: 8, right: 12, backgroundColor: palette.accent, color: '#fff', fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 12 }}>
          NOW
        </div>
      </div>
    );
  }

  if (status === 'upcoming') {
    return (
      <div style={{ width: '100%', height: 68, boxSizing: 'border-box', borderRadius: 10, backgroundColor: palette.bg, border: `1px solid ${palette.accent}66`, display: 'flex', alignItems: 'center', padding: '0 14px', marginBottom: 8, overflow: 'hidden' }}>
        <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
          <span style={{ fontSize: 24, fontWeight: 700, color: palette.text, lineHeight: 1.2 }}>{time}</span>
          <span style={{ fontSize: 20, color: palette.text, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: 1.3 }}>{title}</span>
        </div>
      </div>
    );
  }

  // tomorrow
  return (
    <div style={{ width: '100%', height: 56, boxSizing: 'border-box', borderRadius: 10, backgroundColor: palette.bg, border: `1px solid ${palette.accent}66`, display: 'flex', alignItems: 'center', padding: '0 12px', marginBottom: 8, overflow: 'hidden' }}>
      <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <span style={{ fontSize: 14, fontWeight: 700, color: palette.text, lineHeight: 1.2, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
          {time}
        </span>
        <span style={{ fontSize: 15, color: palette.text, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: 1.3 }}>{title}</span>
      </div>
    </div>
  );
};
